<template>
  <div>
    <div class="privacy-consent-container" id="privacy-consent-container" v-if="!this.hideConsent">
      <div class="privacy-consent-content">
        <p>We use cookies to provide you with a better browsing experience. <router-link to="page/4f4d2ef1-ade2-43aa-bf2d-4a401bd736c0" title="Cookie and Privacy policy">cookie policy</router-link>
        </p>

        <p>Continue browsing if you're happy with this, by choosing <b>I Accept</b>, you consent to our use of additional cookies and other tracking technologies.</p>
        <div class="privacy-consent-button-content">
          <button type="button" id="accept-privacy-consent-button" class="btn accept-privacy-consent-button" @click="UPDATE_PRIVACY_FIELD('privacy', true)">
            I Accept
          </button></div>
      </div>
    </div>
    <footer>
      <div class="site-footer">
        <div class="container">

          
        </div>
        <div>
          <div class="container">
            <div class="col-12 site-by">
              <div class="row">

                <p></p>

                <p>Powered by <a href="https://www.romabravo.com" target="_blank">Romabravo</a> &ndash; &copy; Copyright Romabravo {{year}}</p>
              </div>
            </div>
          </div>
        </div>

      </div>

    </footer>
  </div>
</template>

<script>
/* eslint-disable */
import commonMixin from "@/mixins/commonMixin";
import {
  cookiePolicyComputed,
  cookiePolicyMutations
} from "@/state/helpers";

export default {
  name: "Footer",
  props: [],
  mixins: [commonMixin],
  data() {
    return {
      year: new Date().getFullYear(),
      hideConsent: false,
      footerLinks: []
    };
  },
  methods: {
    ...cookiePolicyMutations,
    UPDATE_PRIVACY_FIELD(key, value) {
      this.hideConsent = value;
      this.SET_PRIVACY_CONSENT_FIELD(this.getKeyValuePair(key, value));
    }
  },
  computed: {
    ...cookiePolicyComputed,
  },
  created() {
    this.hideConsent = this.privacyConsent.privacy;
  },
  mounted() {
  }
};
</script>

<style scoped>
.site-footer {
  padding: 0;
  margin: 0;
}
.site-footer {
  background: #eee;
  height: auto;
  padding: 15px 0;
  color: #545454;
}
.site-footer p {
  display: block;
  clear: both;
  width: 100%;
  font-size: 0.85em;
}
.site-footer a {
  color: #545454;
  text-decoration: none;
}
.site-footer a:hover {
  text-decoration: underline;
}

.site-footer ul {
  padding-left: 0;
  margin-left: 0;
  margin-bottom: 30px;
}
.site-footer ul li {
  list-style: none;
  margin-bottom: 8px;
  font-size: 0.75em;
}
.site-footer h4 {
  font-size: 0.85em;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 0.85rem;
}
.site-by {
  text-align: right;
}
/*-------------- privacy consent --------------  */
.privacy-consent-container {
  background-color: rgba(60, 60, 60, 0.95);
  opacity: 0.95;
  bottom: 0;
  color: #fff;
  font-size: 1.09em;
  font-weight: normal;
  line-height: 1.15em;
  left: 0;
  position: fixed;
  right: 0;
  z-index: 200;
  line-height: 1.5em ;
  /* font-family: "Open Sans", sans-serif; */
}

.privacy-consent-content {
  margin: 0 auto;
  max-width: 800px;
  padding: 30px;
}
.privacy-consent-content a {
  color: #fff;
}
.accept-privacy-consent-button {
  display: block;
  font-weight: bold;
  height: 46px;
  line-height: 46px;
  padding: 0 2em;
  margin: 0 auto;
  min-width: 200px;
}
.privacy-consent-button-content button {
  border: 2px solid #ffffff;
  background-color: #000;
  color: #ffffff;
  display: block;
  font-weight: 600;
  padding: 0rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0rem;
  transition: color 400ms linear;
}
.privacy-consent-button-content button:hover {
  /* border: 2px solid #000;
  background-color: #ffffff;
  color: #000; */
  color: #f9d741;
}
@media (max-width: 768px) {
  .site-footer .container{
    width: 100%;
    max-width: 100%;
  }
}
/*-------------- /privacy consent --------------  */
</style>

